import _slicedToArray from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Framework } from './types.mjs';
import { version } from './version.mjs';
import { detectFramework, observeFrameworkChanges as _observeFrameworkChanges } from './detectFramework.mjs';
import { getCustomUserAgent } from './customUserAgent.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var BASE_USER_AGENT = "aws-amplify";

var PlatformBuilder = /*#__PURE__*/function () {
  function PlatformBuilder() {
    _classCallCheck(this, PlatformBuilder);

    this.userAgent = "".concat(BASE_USER_AGENT, "/").concat(version);
  }

  _createClass(PlatformBuilder, [{
    key: "framework",
    get: function get() {
      return detectFramework();
    }
  }, {
    key: "isReactNative",
    get: function get() {
      return this.framework === Framework.ReactNative || this.framework === Framework.Expo;
    }
  }, {
    key: "observeFrameworkChanges",
    value: function observeFrameworkChanges(fcn) {
      _observeFrameworkChanges(fcn);
    }
  }]);

  return PlatformBuilder;
}();

var Platform = new PlatformBuilder();

var getAmplifyUserAgentObject = function getAmplifyUserAgentObject() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      action = _ref.action;

  var userAgent = [[BASE_USER_AGENT, version]];

  if (category) {
    userAgent.push([category, action]);
  }

  userAgent.push(['framework', detectFramework()]);

  if (category && action) {
    var customState = getCustomUserAgent(category, action);

    if (customState) {
      customState.forEach(function (state) {
        userAgent.push(state);
      });
    }
  }

  return userAgent;
};

var getAmplifyUserAgent = function getAmplifyUserAgent(customUserAgentDetails) {
  var userAgent = getAmplifyUserAgentObject(customUserAgentDetails);
  var userAgentString = userAgent.map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        agentKey = _ref3[0],
        agentValue = _ref3[1];

    return agentKey && agentValue ? "".concat(agentKey, "/").concat(agentValue) : agentKey;
  }).join(' ');
  return userAgentString;
};

export { Platform, getAmplifyUserAgent, getAmplifyUserAgentObject };